import React from 'react';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
export function App({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="min-h-screen w-full flex flex-col bg-gray-50" data-id="element-0">
      <Navigation data-id="element-1" />
      <main className="flex-1" data-id="element-2">{children}</main>
      <Footer data-id="element-3" />
    </div>;
}